import { IconProps } from './types';

export const MusicalNoteIcon = ({ fill = '#fff', ...props }: IconProps) => (
  <svg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 298.274 298.274'>
    <path
      // eslint-disable-next-line max-len
      d='M109.927,33v176.646c-9-8.76-21.559-14.146-35.278-14.146c-28.379,0-51.332,23.007-51.332,51.387  c0,28.381,23.035,51.388,51.414,51.388c28.381,0,51.403-22.928,51.403-51.309c0-0.016-0.165,0.034-0.165,0.034l-0.042-5.386V99  l133-29.456v104.103c-9-8.76-21.559-14.146-35.278-14.146c-28.379,0-51.332,23.007-51.332,51.387  c0,28.381,23.035,51.388,51.414,51.388c28.344,0,51.165-22.946,51.225-51.274l-0.03-3.75V66V0L109.927,33z'
      fill={fill}
      {...props}
    />
  </svg>
);
